import { conformToMask } from 'react-text-mask'

const phoneMask = [
  '(',
  /[1-9]/,
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
]
const ssnMask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
const dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
const getConformedMask = (text, mask, defaultValue = null, config = {}) =>
  text ? conformToMask(text, mask, config).conformedValue : defaultValue

const maskEmail = email => {
  const lastIndex = email.lastIndexOf('@')
  const domainLastIndex = email.lastIndexOf('.')
  const prefix = email.substring(0, lastIndex)
  const domain = email.substring(lastIndex, domainLastIndex)
  const postfix = email.substring(domainLastIndex)
  const mask = '*'.repeat(prefix.length - 2)
  const domainMask = '*'.repeat(domain.length - 3)

  return `${prefix.substring(0, 1)}${mask}${prefix.substring(
    prefix.length - 1
  )}${domain.substring(0, 2)}${domainMask}${domain.substring(
    domain.length - 1
  )}${postfix}`
}

const maskBankNumber = number => {
  return `${'*'.repeat(number.length - 4)}${number.substring(
    number.length - 4
  )}`
}

const maskTextNumber = (datatext, character, nonMask = 4, nMask = 0) => {
  const text = String(datatext)
  const n = text.length

  if (n === 0 || nonMask > n) return datatext

  const vChars = Math.min(nonMask, n)
  const firstpart = text.slice(0, -1 * vChars)
  const lastpart = text.slice(n - vChars)
  const maskFirst = nMask === 0 ? character.repeat(firstpart.length) : character.repeat(nMask)

  return maskFirst + lastpart
}

export {
  maskEmail,
  phoneMask,
  ssnMask,
  dateMask,
  getConformedMask,
  maskBankNumber,
  maskTextNumber,
}
